import React from "react";

import {ASSET_MODAL_TYPE_NEW} from "../constants";
import EquityForm from "./components/EquityForm";
import InsuranceForm from "./components/InsuranceForm";
import CashForm from "./components/CashForm";
import ImmobilienForm from "./components/ImmobilienForm";
import ExternalAssetForm from "./components/ExternalAssetForm";
import LiquidAssetsForm from "./components/LiquidAssetsForm";
import OtherDepotForm from "./components/OtherDepotForm";
import CryptoCurrencyForm from "./components/CryptoCurrencyForm";
import TangibleForm from "./components/TangibleForm";
import DemandForm from "./components/DemandForm";
import OtherAssetForm from "./components/OtherAssetForm";
import LoanForm from "./components/LoanForm";
import MortgageForm from "./components/MortgageForm";
import CreditCardForm from "./components/CreditCardForm";
import LeasingForm from "./components/LeasingForm";
import LiabilityOtherForm from "./components/LiabilityOtherForm";

// TODO: move more forms into dynamic form schemes
const CATEGORIES_FORMS = {
  [ASSET_MODAL_TYPE_NEW.EQUITY]: EquityForm,
  [ASSET_MODAL_TYPE_NEW.INSURANCE]: InsuranceForm,
  [ASSET_MODAL_TYPE_NEW.CASH]: CashForm,
  [ASSET_MODAL_TYPE_NEW.IMMOBILIEN]: ImmobilienForm,
  [ASSET_MODAL_TYPE_NEW.EXTERNAL]: ExternalAssetForm,
  [ASSET_MODAL_TYPE_NEW.LIQUID]: LiquidAssetsForm,
  [ASSET_MODAL_TYPE_NEW.OTHER_DEPOT]: OtherDepotForm,
  [ASSET_MODAL_TYPE_NEW.CRYPTO]: CryptoCurrencyForm,
  [ASSET_MODAL_TYPE_NEW.TANGIBLE]: TangibleForm,
  [ASSET_MODAL_TYPE_NEW.DEMANDS]: DemandForm,
  [ASSET_MODAL_TYPE_NEW.OTHER]: OtherAssetForm,
  [ASSET_MODAL_TYPE_NEW.LOAN]: LoanForm,
  [ASSET_MODAL_TYPE_NEW.MORTGAGE]: MortgageForm,
  [ASSET_MODAL_TYPE_NEW.CREDIT_CARD]: CreditCardForm,
  [ASSET_MODAL_TYPE_NEW.LEASING]: LeasingForm,
  [ASSET_MODAL_TYPE_NEW.OTHER_LIABILITIES]: LiabilityOtherForm,
};

const AssetForm = ({categoryId, defaults, setFormData, formDataErrors, viewOnly, customerId}) => {
  const Form = CATEGORIES_FORMS[categoryId];

  if (!Form) return null;

  return (
    <Form
      key={defaults.updated}  // re-mount form when asset changed
      defaults={defaults}
      handleFormChange={setFormData}
      errors={formDataErrors}
      viewOnly={viewOnly}
      customerId={customerId}
    />
  )
};

export default AssetForm;